import React from 'react';
import { Clock, TrendingUp, TrendingDown, BarChart3 } from 'lucide-react';

export const SummaryStatsRow = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-white rounded-xl border border-slate-200 p-4">
        <div className="flex items-center gap-2 text-slate-500 text-sm mb-1">
          <Clock className="h-4 w-4" />
          Total Hours
        </div>
        <p className="text-2xl font-bold text-[#1e3a5f]" data-testid="summary-total-hours">
          {stats.totalHours.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        </p>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-4">
        <div className="flex items-center gap-2 text-slate-500 text-sm mb-1">
          <TrendingUp className="h-4 w-4" />
          Premium Hours
        </div>
        <p className="text-2xl font-bold text-[#FF8C42]" data-testid="summary-premium-hours">
          {stats.premiumHours.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        </p>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-4">
        <div className="flex items-center gap-2 text-slate-500 text-sm mb-1">
          <BarChart3 className="h-4 w-4" />
          Avg Premium %
        </div>
        <p className="text-2xl font-bold text-[#4CAF93]" data-testid="summary-avg-premium">
          {stats.avgPremiumPercent.toFixed(1)}%
        </p>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-4">
        <div className="flex items-center gap-2 text-slate-500 text-sm mb-1">
          {stats.trend >= 0 ? (
            <TrendingUp className="h-4 w-4 text-red-500" />
          ) : (
            <TrendingDown className="h-4 w-4 text-green-500" />
          )}
          Period Trend
        </div>
        <p className={`text-2xl font-bold ${stats.trend >= 0 ? 'text-red-500' : 'text-green-500'}`} data-testid="summary-trend">
          {stats.trend >= 0 ? '+' : ''}{stats.trend.toFixed(1)}%
        </p>
      </div>
    </div>
  );
};
